import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  root: {
    height: '100%',
  },
  controlWrapper: {
    [theme.breakpoints.down(theme.size.xs)]: {
      flexDirection: 'column',
      width: '100%',
      alignItems: 'flex-start',
    },
  },
  selectRoot: {
    width: '100%',
    justifyContent: 'space-between',
  },
  filtersBar: {
    padding: 10,
  },
  flex: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
  },
  value: {
    fontSize: 15,
    fontWeight: 400,
    color: '#fff',
  },
  column: {
    display: 'flex',
    flexWrap: 'wrap',
    marginBottom: 20,
    '@media (max-width: 1700px)': {
      flexDirection: 'column',
      alignItems: 'flex-start',
      justifyContent: 'center',
    },
  },
  maintenanceContactInformation: {
    '@media (max-width: 475px)': {
      display: 'none',
    },
  },
  flexWrap: {
    flexWrap: 'wrap',
    marginBottom: 20,
  },
  barWrapper: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    marginBottom: 15,
    '&:last-child': {
      marginBottom: 0,
    },
  },
  btn: {
    marginLeft: 13,
    background: '#F0F3F7',
    '&:hover': {
      background: '#dfe6ee',
    },
  },
  label: {
    marginRight: 20,
    fontSize: 15,
    fontWeight: 600,
    color: '#fff',
    [theme.breakpoints.down(theme.size.xs)]: {
      marginRight: 0,
      marginBottom: 10,
    },
  },
}));
